<template>
  <SiruiSearch
    ref="baseInfoFormRef"
    :query="baseFormData"
    :columns="formColumn"
    :isQueryPanel="false"
    :rules="formRules"
    @changeMethod="changeMethod"
    :isDisabledForm="isDisabledForm"
  >
  </SiruiSearch>
</template>

<script>
  import { baseFormColumn, baseFormRules, baseFormColumn1 } from './index.js';
  import XEUtils from 'xe-utils';
  import goodsApi from '@/api/masterData/goods.js';
  export default {
    name: 'BaseInfoForm',
    props: {
      isDisabledForm: {
        type: Boolean,
        default: false,
      },
      // 网络获取数据反填
      fetchData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        baseFormData: {
          /* billNo: '',
          billStatus: '',
          contractNo: '',
          parkCompanyName: '',
          gmtCreate: '',
          fullWarehousTime: '',
          fullDeliveryTime: '',
          parkDepartmentName: '',
          goodsType: '',
          goodsCategory: '',
          contractQuantity: '',
          operatorName: '',
          pledgorName: '',
          pledgorNo: '',
          pledgeeName: '',
          pledgeeNo: '',
          relatedName: '',
          relatedNo: '',
          unit: '',
          remark: '' */
        },
        status: '',
        billStatus: '',
        goodsCategory: '',
        supervisionBillStatusList: [], // 监管单状态
        goodsTypeList: [], // 货物品类
        goodsCategoryList: [], // 获取类型
      };
    },
    computed: {
      formColumn() {
        if (this.status == 'detail' || this.status == 'approval') {
          return baseFormColumn(this);
        } else if (this.status == 'edit') {
          return baseFormColumn1(this);
        }
        return [];
      },
      formRules() {
        return baseFormRules(this);
      },
    },
    mounted() {
      this.status = this.$route.query.status;
      this.supervisionBillStatusList = this.dictListMap.SuperviseBillStatusType;
      this.billStatus = this.translateBillStatus(this.baseFormData.billStatus);
      if (this.status == 'edit') {
        this.initData();
      }
      this.getGoodsParentApi(); // 获取商品大类类
    },
    methods: {
      initData() {
        this.baseFormData.parkCompanyName = this.userInfo.companyName;
        this.baseFormData.parkDepartmentName = this.userInfo.departmentName;
        this.baseFormData.operatorName = this.userInfo.userName;
        this.baseFormData.gmtCreate = this.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
      },
      // 获取表格数据
      async getTableData() {
        return await this.$refs.baseInfoFormRef.getValidateFormData();
      },
      //表格日期回显
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      // 翻译监管单状态
      translateBillStatus(val) {
        return this.supervisionBillStatusList.find((item) => item.value == parseInt(val))?.label;
      },
      // 翻译监管单货物品类
      translateGoodsCategory(val) {
        return this.goodsCategoryList.find((item) => item.value == parseInt(val))?.label;
      },
      changeMethod(row) {
        if (row.prop == 'goodsType') {
          this.baseFormData.goodsCategory = [];
          this.getGoodsCategoryApi();
          if (this.baseFormData.billStatus == '01') {
            this.$emit('changeGoods', this.baseFormData.goodsType);
          }
        } else if (row.prop == 'goodsCategory') {
          if (this.baseFormData.billStatus == '01') {
            this.$emit('changeCategory', this.baseFormData.goodsCategory);
          }
        }
      },
      // 获取商品大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 根据货物类型查询货物品类
      async getGoodsCategoryApi(goodType) {
        let productParentCodes = [];
        if (goodType) {
          productParentCodes = goodType;
        } else {
          productParentCodes = this.goodsTypeList
            .filter((item) => this.baseFormData.goodsType.includes(item.value))
            .map((item) => item.value);
        }
        // const productParentCodes = this.goodsTypeList
        //   .filter((item) => this.baseFormData.goodsType.includes(item.value))
        //   .map((item) => item.value);
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          productParentCodes,
        });
        if (data.code == 0) {
          this.goodsCategoryList = data.data?.map((item) => {
            return {
              value: item.productDetailCode,
              label: item.productChName,
              selectCompanyCode: this.userInfo.companyCode,
              adminFlag: this.userInfo.adminFlag,
            };
          });
          // 过滤掉不在goodsCategoryList 中的goodsCategory
          // goodsType为空，清空goodsCategory
          this.baseFormData.goodsCategory = this.goodsCategoryList
            .filter((item) => this.baseFormData.goodsCategory.includes(item.value))
            .map((item) => item.value);
          if (this.baseFormData.goodsType.length == 0) {
            this.baseFormData.goodsCategory = [];
          }
        } else {
          console.error('获取货物类型数据失败');
        }
      },
    },
    watch: {
      fetchData: {
        handler(val) {
          console.log('基础信息的数据改变了');
          if (val && Object.keys(val).length) {
            let newObj = {};
            for (const key in val) {
              if (key == 'contractQuantity') {
                if (val[key] == null || val[key] == '') {
                  newObj[key] = '0';
                } else {
                  newObj[key] = (val[key] - 0).toFixed(0);
                }
              } else if (key == 'relatedNo') {
                if (val['relatedName'] == null) {
                  newObj[key] == '';
                } else {
                  newObj[key] = val[key];
                }
              } else if (key == 'goodsType' || key == 'goodsCategory') {
                newObj[key] = val[key].split(',');
              } else if (val[key] == null || val[key] == '') {
                newObj[key] = ' ';
              } else {
                newObj[key] = val[key];
              }
            }
            this.baseFormData = {
              ...newObj,
            };
            this.$nextTick(function () {
              this.getGoodsCategoryApi(newObj['goodsType']);
            });
            if (this.$route.query?.status == 'edit') {
              this.initData();
            }
          } else {
            this.initData();
          }
        },
        deep: true,
        immediate: true,
      },
    },
  };
</script>

<style></style>
